
const dataInfo = [
  {
    title: "Original Products",
    subTitle:
      "The main components of A. membranaceus are astragalus polysaccharide, flavonoids compounds, saponins compounds.",
  },
  {
    title: "Fast Delivery",
    subTitle:
      "The main components of A. membranaceus are astragalus polysaccharide, flavonoids compounds, saponins compounds.",
  },
  {
    title: "Original Products",
    subTitle:
      "The main components of A. membranaceus are astragalus polysaccharide, flavonoids compounds, saponins compounds.",
  },
  {
    title: "Dedicated Support",
    subTitle:
      "The main components of A. membranaceus are astragalus polysaccharide, flavonoids compounds, saponins compounds.",
  },
];
export default {
  data() {
    return {
      dataInfo,
    };
  },
};
